import { render, staticRenderFns } from "./RecursiveItem.vue?vue&type=template&id=ece7e5b4&scoped=true&"
import script from "./RecursiveItem.vue?vue&type=script&lang=js&"
export * from "./RecursiveItem.vue?vue&type=script&lang=js&"
import style0 from "./RecursiveItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RecursiveItem.vue?vue&type=style&index=1&id=ece7e5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece7e5b4",
  null
  
)

export default component.exports